import React, {PropTypes as T} from 'react';
import NormalPriceType from './normal_pricetype';
import PasswordProtectedPriceType from './password_protected_pricetype';

export default class PriceType extends React.Component {
  static propTypes = {
    id: T.string,
    eventId: T.string,
    priceType: T.shape({
      name: T.string.isRequired,
      code: T.string.isRequired,
      isPasswordProtected: T.bool,
      additionalInfo: T.array
    }),
    price: T.shape({
      priceFormatted: T.string
    })
  };

  render () {
    const {priceType} = this.props;
    return (
      <div data-attribute-code={priceType.code} className="pricetype">
        {
          (priceType.isPasswordProtected && !priceType.isUnlocked)
            ? <PasswordProtectedPriceType {...this.props} />
            : <NormalPriceType {...this.props} />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/pricetype/index.js